import { forwardRef } from 'react'
import type { HTMLAttributes, TableHTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react'

export type TableProps = TableHTMLAttributes<HTMLTableElement>
export const Table = forwardRef<HTMLTableElement, TableProps>(({ className, ...props }, ref) => (
  <table className={className} ref={ref} {...props} />
))
Table.displayName = 'Table'

export type TableHeaderProps = HTMLAttributes<HTMLTableSectionElement>
export const TableHeader = forwardRef<HTMLTableSectionElement, TableHeaderProps>(({ className, ...props }, ref) => (
  <thead className={className} ref={ref} {...props} />
))
TableHeader.displayName = 'TableHeader'

export type TableBodyProps = HTMLAttributes<HTMLTableSectionElement>
export const TableBody = forwardRef<HTMLTableSectionElement, TableBodyProps>(({ className, ...props }, ref) => (
  <tbody className={className} ref={ref} {...props} />
))
TableBody.displayName = 'TableBody'

export type TableFooterProps = HTMLAttributes<HTMLTableSectionElement>
// export const TableFooter = forwardRef<HTMLTableSectionElement, TableFooterProps>(({ className, ...props }, ref) => (
//   <tfoot className={className} ref={ref} {...props} />
// ))
// TableFooter.displayName = 'TableFooter'

export type TableRowProps = HTMLAttributes<HTMLTableRowElement>
export const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>(({ className, ...props }, ref) => (
  <tr className={className} ref={ref} {...props} />
))
TableRow.displayName = 'TableRow'

export type TableHeadProps = ThHTMLAttributes<HTMLTableCellElement>
export const TableHead = forwardRef<HTMLTableCellElement, TableHeadProps>(({ className, ...props }, ref) => (
  <th className={className} ref={ref} {...props} />
))
TableHead.displayName = 'TableHead'

export type TableCellProps = TdHTMLAttributes<HTMLTableCellElement>
export const TableCell = forwardRef<HTMLTableCellElement, TableCellProps>(({ className, ...props }, ref) => (
  <td className={className} ref={ref} {...props} />
))
TableCell.displayName = 'TableCell'

export type TableCaptionProps = TableHTMLAttributes<HTMLTableCaptionElement>
export const TableCaption = forwardRef<HTMLTableCaptionElement, TableCaptionProps>(({ className, ...props }, ref) => (
  <caption className={className} ref={ref} {...props} />
))
TableCaption.displayName = 'TableCaption'
